<template>
  <el-table :data="data.data" style="width: 100%" v-loading="isLoading" stripe class="weekly-scheduling-table">
    <el-table-column prop="hour" label="Hour" width="110">
      <template slot-scope="scope">
        {{ formatHour(scope.row.hour) }}
      </template>
    </el-table-column>
    <el-table-column prop="sun" :label="labelWithDate('Sun')" width="110"/>
    <el-table-column prop="mon" :label="labelWithDate('Mon')" width="110"/>>
    <el-table-column prop="tues" :label="labelWithDate('Tues')" width="110"/>
    <el-table-column prop="wed" :label="labelWithDate('Wed')" width="110"/>
    <el-table-column prop="thurs" :label="labelWithDate('Thurs')" width="110"/>
    <el-table-column prop="fri" :label="labelWithDate('Fri')" width="110"/>
    <el-table-column prop="sat" :label="labelWithDate('Sat')" width="110"/>
  </el-table>
</template>

<script>
import moment from 'moment';
import api from '@/api';

const SHORT_DATE_FORMAT = 'M/D';

export default {
  name: 'WeeklySchedulingTable',
  props: {
    week: {
      type: Object,
      default: null,
    },
    office: {
      type: Number,
      default: null,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      data: {
        data: [],
        hours: [],
      },
    };
  },
  watch: {
    office() {
      this.loadData();
    },
    week() {
      this.loadData();
    },
    isSelected(selected) {
      if (selected) {
        this.loadData();
      }
    },
  },
  methods: {
    labelWithDate(day) {
      if (this.week && this.week.weekStartDate) {
        const formattedDate = moment(this.week.weekStartDate).day(day).format(SHORT_DATE_FORMAT);
        return `${day} (${formattedDate})`;
      }
      return day;
    },
    loadData() {
      const officeId = this.office;
      const priorYearWeekStart = this.week.relatedWeekYearPrior;
      const currentYearWeekStart = this.week.weekStartDate;
      if (officeId && priorYearWeekStart && this.isSelected) {
        this.isLoading = true;
        api.report.getSchedulingReport(officeId, priorYearWeekStart.format(), currentYearWeekStart.format()).then((response) => {
          this.data = response.data;
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    formatHour(hour) {
      if (hour > 12) {
        return `${hour % 12}p`;
      }
      return `${hour}a`;
    },
  },
  mounted() {
    this.loadData();
  },
};

</script>
